import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

const ArrowDownIcon = ({ color = "currentColor", size = 18, strokeWidth = 1.8, className, ...props }) => {
  return /* @__PURE__ */ jsx("svg", {
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    className: clsx("new_icon", className),
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M9.5 18.5938V1.59375M9.5 18.5938L5 13.8569M9.5 18.5938L14 13.8569",
      stroke: color,
      strokeWidth,
      strokeLinecap: "round"
    })
  });
};

export { ArrowDownIcon as default };
//# sourceMappingURL=ArrowDownIcon.js.map
